import React, { useEffect, useState } from "react";
import "./VesselForm.css";
import axios from "axios";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Navbar/Navbar.jsx";
import baseURL from "../../config.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Description as DescriptionIcon,
  CloudUpload as CloudUploadIcon,
  Anchor as AnchorIcon, CloudUpload,

  CalendarToday as CalendarIcon, NoteAdd

} from "@mui/icons-material";
import {
  Container,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
  IconButton,
  Box,

  styled
} from "@mui/material";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const VesselForm = () => {

  const location = useLocation();
  const { id } = useParams();

  const userType = localStorage.getItem("userType");
  const userId = localStorage.getItem("user id");
  // const [token, setToken] = useState("")


  // Function to determine creatorRole


  const [formData, setFormData] = useState(
    location.state?.vessel || {
      // employer_id: "",
      // employer: "",
      vesselOwnerId: userType === "executive" ? null : id,
      creatorTypeId: userType === "executive" ? id : userId,
      creatorRole: userType,
      vesselname: "",
      IMO_Number: "",
      call_sign: "",
      gross_tonage: "",
      kiloWatt: "",
      bhp: "",
      vesseltype: "",
      Flag: "",
      // seagreement: {
      //   originalName: "",
      //   filePath: "",
      // },
      // cbaRef: "",
      // cdagreement: {
      //   originalName: "",
      //   filePath: "",
      // },
      pipolicynumber: "",
      policydateofv: "",
      pipolicydocument: {
        originalName: "",
        filePath: "",
      },
      mlcCert: "",
      mlcExpiryDate: "",
      mlcIssueDate: "",
      CharteredOrCrewing: "",//------------this is for chartered or crewing
      maritimelabourconvention: {
        originalName: "",
        filePath: "",
      },
      fsdnumber: "",
      fsdvalidity: "",
      fsdocument: {
        originalName: "",
        filePath: "",
      },
      dmlcp1: {
        originalName: "",
        filePath: "",
      },
      dmlc2: {
        originalName: "",
        filePath: "",
      },
      dmlcCert1: "",
      dmlcCert2:"",
    });
  const [selectedUnit, setSelectedUnit] = useState("kiloWatt"); // Default to kilowatt
  const navigate = useNavigate();

  const vesselID = location.state?.vessel?._id;
  const company_ID = id;


  const FileUploadField = ({ label, name, file }) => (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2, mt: 2 }}>
      <Typography variant="body1" sx={{ mb: 1 }}>{label}</Typography>
      <Button
        component="label"
        variant="outlined"
        startIcon={<CloudUpload />}
       sx={{ color:"#C30B12"}}
      >
        Upload File
        <VisuallyHiddenInput
          type="file"
          name={name}
          onChange={handleFileChange}
        />
      </Button>
      <Typography variant="caption" sx={{ ml: 2 }}>
        {file?.originalName || "No file selected"}
      </Typography>
    </Box>
  );


  useEffect(() => {
    if (id) {
      // setToken(localStorage.getItem("token"));
      const token = localStorage.getItem("token");
      axios
        .get(`${baseURL}/api/vesselOwnerformById/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const companyData = response.data.data;

          setFormData((prevData) => ({
            ...prevData,
            employer: companyData.company_name || "",
            employer_id: companyData._id || company_ID || "",
          }));
        })
        .catch((error) => {
          console.error("Error fetching company data:", error);
          toast.error("Failed to fetch company data.", error.message);
        });
    }
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split('T')[0];
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: {
          originalName: files[0].name, // Store the file's name
          file: files[0], // Store the actual file object
        },
      }));
    }
  };

  const handleUnitChange = (e) => {
    setSelectedUnit(e.target.value);
  };

  const handlesubmit = async (e) => {
    e.preventDefault();

    // Clone formData to safely manipulate it
    const dataToSend = { ...formData };

    // Ensure only selected power unit is included
    if (selectedUnit === "kiloWatt") {
      delete dataToSend.bhp;
    } else if (selectedUnit === "bhp") {
      delete dataToSend.kiloWatt;
    }

    // Create FormData object
    const FormDataToSend = new FormData();

    // Append all form fields to FormData
    for (const key in formData) {
      if (formData[key]) {
        if (formData[key]?.file) {
          // If the field is a file, append the file object
          FormDataToSend.append(key, formData[key].file);
        } else {
          // Otherwise, append the field value
          FormDataToSend.append(key, formData[key]);
        }
      }
    }

    // Retrieve token from localStorage
    const token = localStorage.getItem("token");

    if (!token) {
      toast.error("Authorization token not found!");
      return;
    }

    try {
      const response = vesselID
        ? await axios.put(`${baseURL}/api/updateVesselDetails/${vesselID}`, FormDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Token included
          },
        })
        : await axios.post(`${baseURL}/api/vesselform`, FormDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`, // Token included
          },
        });

      if (response.status === 200 || response.status === 201) {
        toast.success("Vessel details submitted successfully!");

        // Delay navigation so the toast can be displayed
        setTimeout(() => {
          navigate("/vessel_Table");
        }, 2000);
      }
    } catch (error) {
      console.error("Error uploading form data:", error);
      toast.error(error.response?.data?.message || "Failed to submit vessel details.");
    }
  };

  return (
    <>
      <ToastContainer />
      <Navbar />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <AnchorIcon  sx={{ fontSize: 50 , color: "#C30B12"}} />
            <Typography variant="h4" component="h1" gutterBottom>
              Vessel Registration
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              Fill in the details below to register your vessel
            </Typography>
          </Box>

          <form onSubmit={handlesubmit}>
            {/* Ship Details Section */}
            <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 3 }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3, color: "#C30B12" }}>
                <DescriptionIcon sx={{ mr: 1, verticalAlign: "middle" }} />
                Ship Information
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <Select
                      name="CharteredOrCrewing"
                      value={formData.CharteredOrCrewing || "Crewing"}
                      onChange={handleInputChange}
                    >
                      <MenuItem value="Chartered">Chartered</MenuItem>
                      <MenuItem value="Crewing">Crewing</MenuItem>
                    </Select>
                  </FormControl>


                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Name of Ship"
                    name="vesselname"
                    value={formData.vesselname}
                    onChange={handleInputChange}
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="IMO Number"
                    name="IMO_Number"
                    value={formData.IMO_Number}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Call Sign"
                    name="call_sign"
                    value={formData.call_sign}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Gross Tonnage"
                    name="gross_tonage"
                    value={formData.gross_tonage}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    <FormControl fullWidth>
                      <InputLabel>Power Unit</InputLabel>
                      <Select
                        value={selectedUnit}
                        onChange={handleUnitChange}
                        label="Power Unit"
                      >
                        <MenuItem value="kiloWatt">kW (KiloWatt)</MenuItem>
                        <MenuItem value="bhp">BHP</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      fullWidth
                      type="number"
                      label="Power Value"
                      value={formData[selectedUnit] || ""}
                      onChange={(e) => setFormData({ ...formData, [selectedUnit]: e.target.value })}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Ship Type"
                    name="vesseltype"
                    value={formData.vesseltype}
                    onChange={handleInputChange}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Ship Flag"
                    name="Flag"
                    value={formData.Flag}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Paper>

            {/* P&I Details Section */}
            <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 3 }}>

              <Typography variant="h5" gutterBottom sx={{ mb: 3, color: "#C30B12" }}>
                <NoteAdd sx={{ mr: 1, verticalAlign: 'middle' }} />
                P&I Insurance Details
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Policy Number"
                    name="pipolicynumber"
                    value={formData.pipolicynumber}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Policy Validity Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    name="policydateofv"
                    value={formatDate(formData.policydateofv)}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FileUploadField
                    label="P&I Policy Document"
                    name="pipolicydocument"
                    file={formData.pipolicydocument}
                  />
                </Grid>
              </Grid>
            </Paper>

            {/* Financial Security Section */}
            <Paper elevation={0} sx={{ p: 3, mb: 4, border: 1, borderColor: 'divider' }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3 , color:"#C30B12" }}>
                <NoteAdd sx={{ mr: 1, verticalAlign: 'middle' }} />
                Financial Security Details
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Document Number"
                    name="fsdnumber"
                    value={formData.fsdnumber}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Validity Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    name="fsdvalidity"
                    value={formatDate(formData.fsdvalidity)}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FileUploadField
                    label="Financial Security Document"
                    name="fsdocument"
                    file={formData.fsdocument}
                  />
                </Grid>
              </Grid>
            </Paper>

            {/* MLC Section */}
            <Paper elevation={3} sx={{ p: 4, mb: 4, borderRadius: 3 }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3, color: "#C30B12" }}>
                <NoteAdd sx={{ mr: 1, verticalAlign: 'middle' }} />
                Maritime Labour Convention (MLC) Details
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="MLC Certificate Number"
                    name="mlcCert"
                    value={formData.mlcCert}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Issue Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    name="mlcIssueDate"
                    value={formatDate(formData.mlcIssueDate)}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Expiry Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    name="mlcExpiryDate"
                    value={formatDate(formData.mlcExpiryDate)}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FileUploadField
                    label="MLC Certificate Document"
                    name="maritimelabourconvention"
                    file={formData.maritimelabourconvention}
                  />
                </Grid>
              </Grid>
            </Paper>


            <Paper elevation={0} sx={{ p: 3, mb: 4, border: 1, borderColor: 'divider', borderRadius: 3 }}>
              <Typography variant="h5" gutterBottom sx={{ mb: 3, color:"#C30B12" }}>
                <NoteAdd sx={{ mr: 1, verticalAlign: 'middle' }} />
                DMLC Documents
              </Typography>

              {/* DMLC Part 1 */}
              <Grid container spacing={3} alignItems="flex-start" sx={{ mb: 2 }}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ mt: '4px' }}>
                    <FileUploadField
                      label="DMLC Part 1"
                      name="dmlcp1"
                      file={formData.dmlcp1}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="DMLC Part 1 Certificate Number"
                    name="dmlcCert1"
                    value={formData.dmlcCert1}
                    onChange={handleInputChange}
                    sx={{ mt: 2.25 }}
                  />
                </Grid>
              </Grid>

              {/* DMLC Part 2 */}
              <Grid container spacing={3} alignItems="flex-start">
                <Grid item xs={12} md={6}>
                  <Box sx={{ mt: '4px' }}>
                    <FileUploadField
                      label="DMLC Part 2"
                      name="dmlc2"
                      file={formData.dmlc2}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="DMLC Part 2 Certificate Number"
                    name="dmlcCert2"
                    value={formData.dmlcCert2}
                    onChange={handleInputChange}
                    sx={{ mt: 2.25 }}
                  />
                </Grid>
              </Grid>
            </Paper>



            {/* Form Actions */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
              <Button
                type="submit"
                variant="contained"
                
                size="large"
                sx={{ px: 6 , backgroundColor: "#b8860b"}}
              >
                {vesselID ? 'Update' : 'Submit'}
              </Button>
            </Box>
          </form>
        </Paper>
      </Container>
    </>
  );
};

export default VesselForm;
